import { Product } from "@towersystems/roam-common/lib/generated-types";
import React from "react";

export type SelectedProductEntityType = {
  product: Product;
  setProduct: (product: Product) => void;
};

export const SelectedProductEntityContext = React.createContext<
  SelectedProductEntityType | undefined
>(undefined);
